export default {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    REVOKE: {
        LOADING: 'REVOKE',
        SUCCESS: 'REVOKE_SUCCESS',
        FAILED: 'REVOKE_FAILED'
    }
};
